import { render, staticRenderFns } from "./matterOrder.vue?vue&type=template&id=ce189f6a&scoped=true"
import script from "./matterOrder.vue?vue&type=script&lang=js"
export * from "./matterOrder.vue?vue&type=script&lang=js"
import style0 from "./matterOrder.vue?vue&type=style&index=0&id=ce189f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce189f6a",
  null
  
)

export default component.exports